import * as constants from './constants';
import * as service from './service';
import * as commonConst from '../../common/constants';

export default {
    //快照部分
    [constants.kecGetSnap](ctx, params) {
        params = _.merge(params, service.kecGetSnap);
        return new Promise((resolve, reject) => {
            ctx.dispatch(commonConst.unifiedAjax, params).then(res => {
                if(res.msg) {
                    reject(res.msg)
                } else {
                    ctx.commit(constants.kecGetSnap, res);
                    resolve(res);
                }
            }).catch(e => {
                reject(e);
            });
        });
    },
    [constants.getEbsSnap](ctx, params) {
        params = _.merge(params, service.getEbsSnap);
        return new Promise((resolve, reject) => {
            ctx.dispatch(commonConst.unifiedAjax, params).then(res => {
                if(res.msg) {
                    reject(res.msg)
                } else {
                    resolve(res);
                }
            }).catch(e => {
                reject(e);
            });
        });
    },
    [constants.kecSnapLimitNum](ctx, params) {
        params = _.merge(params, service.kecSnapLimitNum);
        return new Promise((resolve, reject) => {
            ctx.dispatch(commonConst.unifiedAjax, params).then(res => {
                resolve(res);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //试用订单
    [constants.kecTryOrder](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.kecTryOrder);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                if(data.data) {
                    ctx.commit(constants.kecTryOrder, data.data);
                    resolve(data);
                } else {
                    reject(data)
                }
            }).catch(e => {
                reject(e);
            })
        });
    },
    [constants.QueryNetworkResource](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.QueryNetworkResource);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //价格体系
    [constants.QueryKecData](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.QueryKecData);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(constants.QueryKecData, data)
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    // 价格体系：弹性伸缩
    [constants.QueryPriceSystem](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.QueryPriceSystem);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(constants.QueryPriceSystem, data)
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [constants.kecRegions](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.kecRegions);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(constants.kecRegions, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [constants.kecImageList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.kecImageList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(constants.kecImageList, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [constants.kecDiyImage](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.kecDiyImage);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(constants.kecDiyImage, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [constants.kecQueryDisCount](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge({params: params}, service.kecQueryDisCount);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                let disCountObj  = {};
                if(!_.isEmpty(data.data)) {
                    _.each(data.data, (item) =>{
                        disCountObj[item.product_type_id] = item.rebate;
                    });
                } else {
                    if(_.indexOf(params.params.ProductTypes,",") !=-1){
                        let arr = params.params.ProductTypes.split(',');
                        _.each(arr, (item) => {
                            disCountObj[item] = 1;
                        });
                    }else{
                        disCountObj[params.params.ProductTypes] = 1;
                    }
                }
                // console.log(disCountObj)
                ctx.commit(constants.kecQueryDisCount, {
                    disCountObj: disCountObj
                });
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [constants.kecCalcKvmPrice](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.kecCalcKvmPrice);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [constants.calculateResPrice](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.calculateResPrice);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取镜像市场tab列表
    [constants.describeMarketTAbList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.describeMarketTAbList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取镜像市场镜像
    [constants.describeMarketImage](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.describeMarketImage);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取竞价实例 历史价格
    [constants.DescribeSpotPriceHistory](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.DescribeSpotPriceHistory);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [constants.QueryMaxBootNum](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.QueryMaxBootNum);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    //修改实例模板（获取单个实例模板的数据）
    [constants.DescribeModels](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.DescribeModels);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取主机详情（获取单个实例的数据）
    [constants.GetInstanceByIds](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.GetInstanceByIds);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    //获取通用折扣信息
    [constants.queryCommonDiscount](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.queryCommonDiscount);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [constants.batchCalculateKVMPrice](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.batchCalculateKVMPrice);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [constants.GetQuota](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.GetQuota);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [constants.checkSnapShotPermission](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.checkSnapShotPermission);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.DescribeSnapshotServiceStatus](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.DescribeSnapshotServiceStatus);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.openSnapShotService](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.openSnapShotService);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e)
            })
        })
    },
    [constants.DescribeInstanceGroupCount](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.DescribeInstanceGroupCount);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e)
            })
        })
    },

    //查询云盘类型的全部性能配额配置
    [constants.DescribeEbsPerfQuotas](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.DescribeEbsPerfQuotas);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e)
            })
        })
    },

    //--以下为未登录actions--
    //价格体系
    [constants.noLoginQueryKecData](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.noLoginQueryKecData);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(constants.noLoginQueryKecData, data)
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [constants.noLoginkecImageList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.noLoginkecImageList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(constants.noLoginkecImageList, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [constants.noLoginKecQueryDisCount](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge({params: params}, service.noLoginKecQueryDisCount);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                let disCountObj  = {};
                if(!_.isEmpty(data.data)) {
                    _.each(data.data, (item) =>{
                        disCountObj[item.product_type_id] = item.rebate;
                    });
                } else {
                    if(_.indexOf(params.params.ProductTypes,",") !=-1){
                        let arr = params.params.ProductTypes.split(',');
                        _.each(arr, (item) => {
                            disCountObj[item] = 1;
                        });
                    }else{
                        disCountObj[params.params.ProductTypes] = 1;
                    }
                }
                // console.log(disCountObj)
                ctx.commit(constants.noLoginKecQueryDisCount, {
                    disCountObj: disCountObj
                });
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    //获取通用折扣信息
    [constants.noLoginQueryCommonDiscount](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.noLoginQueryCommonDiscount);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    // --以上为未登录actions--
}
